import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registerActions from './actions/';
import { withAlert } from 'react-alert';
import LoadingModal from '../../components/LoadingModal';
import AuthService from '../../services/api/auth';
import Cookies from 'universal-cookie';
import ErrorList from '../../components/ErrorList';

const cookies = new Cookies();
class MultiService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            services: [],
        };
    }

    componentDidMount() {
        this.props.setStep('SERVICES');
        const selectedServiceId = cookies.get('serviceId');

        AuthService.getServices().then(data => {
            this.setState({
                loading: false,
                services: data.map(item => {
                    return {
                        ...item,
                        checked: selectedServiceId === item.id ? true : item.checked,
                    };
                }),
            });
        });
    }

    handleServiceChange(i, checked) {
        const services = this.state.services.map((item, k) => {
            if (k === i) {
                return {
                    ...item,
                    checked,
                };
            } else {
                return item;
            }
        });
        this.setState({
            services,
        });
    }

    handleRequiredStep(item) {
        const requiredSteps = item.requiredSteps.filter(step => step.indexOf('_CHECK') === -1);
        requiredSteps.forEach((step, index) => {
            requiredSteps[index] = window.VULOG_TRANSLATE(step);
        });
        return requiredSteps.join(', ');
    }

    save() {
        this.setState({
            loading: true,
            errors: [],
        });
        const services = this.state.services.filter(service => service.checked);
        if (services.length === 0) {
            return this.setState({
                loading: false,
                errors: ['No services selected'],
            });
        }
        AuthService.saveServices(this.state.services.filter(service => service.checked)).then(response => {
            cookies.set('serviceId', null);
            if (response.steps) {
                window.VULOG_CONFIG.STEPS = response.steps;
            }
            if (response.next === null) {
                this.props.history.push('/register/status');
            } else {
                this.props.history.push(response.next);
            }
        });
    }

    render() {
        return (
            <div className="container-fluid wrapper services">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <h3 className="page__title">{window.VULOG_TRANSLATE('MULTI_SERVICE_TITLE')}</h3>
                </div>
                <div className="flex-grow-1">
                    {window.VULOG_CONFIG && window.VULOG_CONFIG.ERROR_DISPLAY_TOP && (
                        <ErrorList errors={this.state.errors} />
                    )}

                    {this.state.services.map((item, i) => {
                        return (
                            <div key={item.name} className={`service-entry ${item.disabled ? 'service-disabled' : ''}`}>
                                <div className={'service-body'}>
                                    <div className={'service-description'}>{item.name}</div>
                                    <div>
                                        <input
                                            type={'checkbox'}
                                            disabled={item.disabled}
                                            className="custom-checkbox"
                                            id={`service-${i}`}
                                            checked={item.checked}
                                            onChange={event => this.handleServiceChange(i, event.target.checked)}
                                        />
                                        <label htmlFor={`service-${i}`} />
                                    </div>
                                </div>
                                <div className={'service-footer'}>Required: {this.handleRequiredStep(item)}</div>
                            </div>
                        );
                    })}
                    {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} />}
                </div>
                <div className="d-flex flex-row mt-auto mb-1-5rem">
                    <button className="btn btn-primary btn-block" onClick={() => this.save()}>
                        {window.VULOG_TRANSLATE('Next')}
                        <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                    </button>
                </div>
                <LoadingModal loading={this.state.loading} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        position: state.register.position,
    };
}
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

function mapDispatchToProps(dispatch) {
    return bindActionCreators(registerActions, dispatch);
}

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(MultiService));
